import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { MenuItemComponent } from './menu-item.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [MenuItemComponent],
  exports: [MenuItemComponent],
})
export class MenuItemModule { }
